import React, { useState, useEffect, useContext } from 'react';
import ThemeContext from '../context/ThemeContext.jsx';
import { FaSun, FaMoon, FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa';
import { HiOutlineMenuAlt3, HiX } from 'react-icons/hi';

const navLinks = [
  { href: '#beneficii', label: 'Ce primești' },
  { href: '#testimoniale', label: 'Rezultate' },
  { href: '#galerie', label: 'Galerie' },
  { href: '#contact', label: 'Contact' }
];

const Header = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <header
      className={`fixed top-0 w-full z-40 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 dark:bg-dark-950/95 backdrop-blur-xl shadow-[0_1px_0_rgba(0,0,0,0.05)] dark:shadow-[0_1px_0_rgba(255,255,255,0.05)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo - personal name, not brand */}
          <a
            href="#hero"
            className={`text-base sm:text-lg font-extrabold tracking-tight transition-colors duration-300 ${
              scrolled
                ? 'text-dark-900 dark:text-white'
                : 'text-white'
            }`}
            aria-label="Catalin Dorca"
          >
            Cătălin Dorca
            <span className={`hidden sm:inline text-xs font-medium ml-2 ${
              scrolled ? 'text-dark-400' : 'text-white/50'
            }`}>
              Personal Trainer
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-0.5">
            {navLinks.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className={`px-3.5 py-2 text-[13px] font-medium rounded-lg transition-colors duration-200 ${
                  scrolled
                    ? 'text-dark-500 dark:text-dark-400 hover:text-dark-900 dark:hover:text-white hover:bg-dark-50 dark:hover:bg-dark-800/50'
                    : 'text-white/60 hover:text-white hover:bg-white/10'
                }`}
              >
                {label}
              </a>
            ))}
          </nav>

          {/* Right */}
          <div className="flex items-center gap-1.5">
            <button
              onClick={toggleTheme}
              className={`p-2 rounded-lg transition-colors duration-200 ${
                scrolled
                  ? 'text-dark-400 hover:bg-dark-50 dark:hover:bg-dark-800/50'
                  : 'text-white/50 hover:bg-white/10'
              }`}
              aria-label="Comută tema"
            >
              {theme === 'dark' ? <FaSun size={15} className="text-amber-400" /> : <FaMoon size={15} />}
            </button>

            <a
              href="/quiz"
              className={`hidden sm:inline-flex items-center px-4 py-2 text-[13px] font-semibold rounded-full transition-all duration-200 ${
                scrolled
                  ? 'bg-primary text-white hover:bg-primary-700'
                  : 'bg-white/15 text-white border border-white/20 hover:bg-white/25'
              }`}
            >
              Aplică acum
            </a>

            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className={`md:hidden p-2 rounded-lg transition-colors duration-200 ${
                scrolled
                  ? 'text-dark-600 dark:text-dark-300 hover:bg-dark-50 dark:hover:bg-dark-800/50'
                  : 'text-white hover:bg-white/10'
              }`}
              aria-label="Meniu"
            >
              {menuOpen ? <HiX size={20} /> : <HiOutlineMenuAlt3 size={20} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          menuOpen ? 'max-h-[28rem] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="bg-white dark:bg-dark-950 border-t border-dark-100 dark:border-dark-800 px-5 pb-6 pt-2">
          <ul className="space-y-0.5">
            {navLinks.map(({ href, label }) => (
              <li key={href}>
                <a
                  href={href}
                  onClick={handleNavClick}
                  className="block py-3 px-3 text-dark-600 dark:text-dark-300 hover:text-primary font-medium rounded-lg hover:bg-dark-50 dark:hover:bg-dark-900 transition-colors text-sm"
                >
                  {label}
                </a>
              </li>
            ))}
            <li className="pt-3">
              <a
                href="/quiz"
                onClick={handleNavClick}
                className="btn-primary w-full text-center text-sm"
              >
                Aplică acum
              </a>
            </li>
          </ul>
          <div className="flex items-center gap-4 pt-5 mt-4 border-t border-dark-100 dark:border-dark-800">
            <a href="https://www.facebook.com/dorca.catalin" aria-label="Facebook" className="text-dark-400 hover:text-primary transition-colors"><FaFacebookF size={16} /></a>
            <a href="https://www.instagram.com/catalin_dorca.pt/" aria-label="Instagram" className="text-dark-400 hover:text-primary transition-colors"><FaInstagram size={16} /></a>
            <a href="https://www.tiktok.com/@catalin.dorca.pt" aria-label="TikTok" className="text-dark-400 hover:text-primary transition-colors"><FaTiktok size={16} /></a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
